// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CrossRotate {\r\n  padding-left: 4px;\r\n}\r\n\r\n.CrossRotate .u-checkbox {\r\n  display: block !important;\r\n  margin-bottom: 4px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.CrossRotateTitle {\r\n  text-align: center;\r\n  background-color: #eee;\r\n  height: 30px;\r\n  padding-top: 7px;\r\n}\r\n\r\n.CrossRotateLeftField {\r\n  width: 200px;\r\n  float: left;\r\n  overflow: auto;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
